import { connect } from 'react-redux';
import ShareLinkPopUp from '../../components/sections/ShareLinkPopUp';

const mapStateToProps = state => {
  return {
    configurationUrl: state.configurationUrl,
  };
};

const ShareLinkPopUpRedux = connect(mapStateToProps, {})(ShareLinkPopUp);

export default ShareLinkPopUpRedux;
